import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "card-header border-0" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("h2", null, "Records")
  ])
], -1)
const _hoisted_2 = { class: "card-body pt-0 pb-5" }
const _hoisted_3 = { class: "col-lg-8 fv-row" }
const _hoisted_4 = { class: "fv-plugins-message-container" }
const _hoisted_5 = { class: "fv-help-block" }
const _hoisted_6 = { class: "col-lg-8 fv-row" }
const _hoisted_7 = { class: "col-lg-8 fv-row" }
const _hoisted_8 = { style: {"display":"none"} }
const _hoisted_9 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_10 = {
  key: 0,
  type: "submit",
  id: "kt_account_profile_details_submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_11 = { class: "indicator-label" }
const _hoisted_12 = { class: "indicator-progress" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`card pt-4 ${_ctx.cardClasses}`)
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Datatable, {
        "table-header": _ctx.tableHeader,
        "table-data": _ctx.tableData,
        loading: _ctx.loading,
        "rows-per-page": 40,
        "enable-items-per-page-dropdown": false
      }, {
        "cell-name": _withCtx(({ row: ireSizesValues }) => [
          _createTextVNode(_toDisplayString(ireSizesValues.sizeTitle +
            ' ' +
            ireSizesValues.propertyTypeTitle +
            ' - ' +
            ireSizesValues.flooringTitle), 1)
        ]),
        "cell-propertySize": _withCtx(({ row: ireSizesValues }) => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Field, {
              class: "form-control form-control-solid required",
              type: "number",
              placeholder: _ctx.translate('propertySize'),
              modelValue: ireSizesValues.propertySize,
              "onUpdate:modelValue": ($event: any) => ((ireSizesValues.propertySize) = $event),
              onChange: ($event: any) => (_ctx.changeTableData(ireSizesValues)),
              name: "propertySize"
            }, null, 8, ["placeholder", "modelValue", "onUpdate:modelValue", "onChange"]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_ErrorMessage, { name: "propertySize" })
              ])
            ])
          ])
        ]),
        "cell-descriptionAr": _withCtx(({ row: ireSizesValues }) => [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_Field, {
              as: "textarea",
              name: "descriptionAr",
              autocomplete: "off",
              modelValue: ireSizesValues.descriptionAr,
              "onUpdate:modelValue": ($event: any) => ((ireSizesValues.descriptionAr) = $event),
              class: "form-control form-control-lg form-control-solid",
              onChange: ($event: any) => (_ctx.changeTableData(ireSizesValues)),
              placeholder: _ctx.translate('descriptionAr')
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange", "placeholder"])
          ])
        ]),
        "cell-descriptionEn": _withCtx(({ row: ireSizesValues }) => [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_Field, {
              as: "textarea",
              name: "descriptionEn",
              autocomplete: "off",
              modelValue: ireSizesValues.descriptionEn,
              "onUpdate:modelValue": ($event: any) => ((ireSizesValues.descriptionEn) = $event),
              class: "form-control form-control-lg form-control-solid",
              onChange: ($event: any) => (_ctx.changeTableData(ireSizesValues)),
              placeholder: _ctx.translate('descriptionEn')
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange", "placeholder"])
          ])
        ]),
        "cell-actions": _withCtx(({ row: ireSizesValues }) => [
          _createElementVNode("h1", _hoisted_8, _toDisplayString(ireSizesValues.value), 1)
        ]),
        _: 1
      }, 8, ["table-header", "table-data", "loading"])
    ]),
    _createVNode(_component_Form, {
      class: "form",
      onSubmit: _ctx.onSubmitUpdate
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
            type: "reset",
            class: "btn btn-white btn-active-light-primary me-2",
            ref: "submitButton"
          }, _toDisplayString(_ctx.translate('discard')), 513),
          (_ctx.can('update', 'instant-rent-estimator'))
            ? (_openBlock(), _createElementBlock("button", _hoisted_10, [
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.translate('saveChanges')), 1),
                _createElementVNode("span", _hoisted_12, [
                  _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                  _hoisted_13
                ])
              ], 512))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["onSubmit"])
  ], 2))
}